import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    buildingItems: [],
    roomItems: [],
    totalItems: 0
  },
  getters: {
    loadingStatus (state) {
      return state.loadingStatus
    },
    buildingItems (state) {
      return state.buildingItems
    },
    roomItems (state) {
      return state.roomItems
    },
    totalItems (state) {
      return state.totalItems
    }
  },
  mutations: {
    SET_LOADING_STATUS (state, payload) {
      state.loadingStatus = payload
    },
    SET_BUILDING_ITEMS (state, payload) {
      state.buildingItems = payload
    },
    SET_ROOM_ITEMS (state, payload) {
      state.roomItems = payload
    },
    SET_TOTAL_ITEMS (state, payload) {
      state.totalItems = payload
    }
  },
  actions: {
    loadBuildingItems (context) {
      console.log('actions loadBuildingItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/buildings`).then((response) => {
        console.log('Buildings', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_BUILDING_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbar/snackbarOnLoadFail', error)
      })
    },
    loadRoomItems (context) {
      console.log('actions loadRoomItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/rooms`).then((response) => {
        console.log('Rooms', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_ROOM_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbar/snackbarOnLoadFail', error)
      })
    },
    loadBuildingItemsAsPage (context, pagination) {
      console.log('actions loadBuildingItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/buildings/page`, { params: pagination }).then((response) => {
        console.log('Buildings', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_BUILDING_ITEMS', response.data.items)
        context.commit('SET_TOTAL_ITEMS', response.data.totalItems)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbar/snackbarOnLoadFail', error)
      })
    },
    loadRoomItemsAsPage (context, pagination) {
      console.log('actions loadRoomItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/rooms/page`, { params: pagination }).then((response) => {
        console.log('Rooms', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_ROOM_ITEMS', response.data.items)
        context.commit('SET_TOTAL_ITEMS', response.data.totalItems)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbar/snackbarOnLoadFail', error)
      })
    },
    createBuilding ({ commit, dispatch }, payload) {
      console.log('-> createBuildings', payload)
      return Vue.axios.post(`${config.serverURI}/buildings`, payload)
    },
    updateBuilding ({ commit, dispatch }, payload) {
      console.log('-> updateBuildings', payload)
      return Vue.axios.put(`${config.serverURI}/buildings/${payload.id}`, payload)
    },
    deleteBuilding ({ commit, dispatch }, payload) {
      console.log('-> deleteBuildings', payload)
      return Vue.axios.delete(`${config.serverURI}/buildings/${payload.id}`)
    },
    createRoom ({ commit, dispatch }, payload) {
      console.log('-> createRooms', payload)
      return Vue.axios.post(`${config.serverURI}/rooms`, payload)
    },
    updateRoom ({ commit, dispatch }, payload) {
      console.log('-> updateRooms', payload)
      return Vue.axios.put(`${config.serverURI}/rooms/${payload.id}`, payload)
    },
    deleteRoom ({ commit, dispatch }, payload) {
      console.log('-> deleteRooms', payload)
      return Vue.axios.delete(`${config.serverURI}/rooms/${payload.id}`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/building.js